import { RefObject, useEffect } from 'react';

import { useFocusTrap } from './useFocusTrap';

/**
 * Complete ARIA dialog focus handling:
 * - Moves focus to the dialog element when it opens
 * - Traps focus inside it while open
 * - Restores focus to the previously focused element when it closes
 *
 * The dialog element must have tabIndex={-1}.
 *
 * For focus trapping without the dialog semantics, use useFocusTrap directly.
 */
export const useDialogFocus = (dialogRef: RefObject<HTMLElement>, isOpen: boolean) => {
    useFocusTrap(dialogRef, isOpen);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const triggerElement = document.activeElement instanceof HTMLElement ? document.activeElement : undefined;
        dialogRef.current?.focus();

        return () => triggerElement?.focus();
    }, [dialogRef, isOpen]);
};
